import { fetchWithAnalytics } from '@parcel2go/npm-p2g-app';
import { AddressLookupResponse, AddressSearchResponse } from './types';

export async function exactPostcodeLookup(
  apiPath: string,
  tenant: string,
  session: string,
  country: string,
  postcode: string
) {
  const response = await fetchWithAnalytics(
    session,
    `${apiPath}/${tenant}/order-process/address/exact/${country}?query=${encodeURIComponent(postcode)}`
  );

  if (response.ok) {
    const result = (await response.json()) as AddressSearchResponse;
    if (result.success && result.result && result.result.results.length > 0) {
      return result.result.results[0];
    }
  }
}

export async function addressSearch(
  apiPath: string,
  tenant: string,
  session: string,
  country: string,
  query: string,
  skip: number = 0,
  take: number = 20
) {
  const response = await fetchWithAnalytics(
    session,
    `${apiPath}/${tenant}/order-process/address/search/${country}?query=${encodeURIComponent(query)}&skip=${skip}&take=${take}`
  );

  if (!response.ok) {
    throw new Error(`Failed to search for address invalid http response code ${response.status}`);
  }

  const result = (await response.json()) as AddressSearchResponse;
  if (!result?.success || !result?.result) {
    throw new Error(
      `Failed to search for address invalid api response ${result.error?.code} - ${result.error?.message}`
    );
  }

  return result.result.results || [];
}

export async function addressBreakdown(
  apiPath: string,
  tenant: string,
  session: string,
  country: string,
  query: string,
  id: string
) {
  const response = await fetchWithAnalytics(
    session,
    `${apiPath}/${tenant}/order-process/address/breakdown/${country}/${id}?query=${encodeURIComponent(query)}`
  );
  if (!response.ok) {
    throw new Error(`Failed to breakdown address invalid http response code ${response.status}`);
  }

  const result = (await response.json()) as AddressSearchResponse;
  if (!result?.success || !result?.result) {
    throw new Error(
      `Failed to breakdown address invalid api response ${result.error?.code} - ${result.error?.message}`
    );
  }

  return result.result.results || [];
}

export async function addressRetrieve(apiPath: string, tenant: string, session: string, country: string, id: string) {
  const response = await fetchWithAnalytics(
    session,
    `${apiPath}/${tenant}/order-process/address/search/${country}/${encodeURIComponent(id)}`
  );
  if (!response.ok) {
    throw new Error(`Failed to lookup address invalid http response code ${response.status}`);
  }

  const result = (await response.json()) as AddressLookupResponse;
  if (!result?.success || !result?.result) {
    throw new Error(`Failed to lookup address invalid api response ${result.error?.code} - ${result.error?.message}`);
  }

  return result.result;
}
